<footer class="app-footer">
  <div class="container">
    <div class="footer-top">
      <a class="logo" [routerLink]="['/']"><img src="/assets/images/dryo_cleaners.svg" alt="Dryo logo"></a>
      <div>
        <nav class="footer-menu" aria-label="Footer menu">
          <ul class="menu">
            <li><a href="#services">Services</a></li>
            <li><a href="#pricing">Pricing</a></li>
            <li><a href="#location">Location</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="footer-bottom">
      <p class="copyright">&copy; 2026 Dryo. All rights reserved.</p>
    </div>
  </div>
</footer>
